import React from "react";

const MessageInputSvg = ({ className, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M20.5 5.5H3.5C2.39543 5.5 1.5 6.39543 1.5 7.5V16.5C1.5 17.6046 2.39543 18.5 3.5 18.5H6.5V22.5L11.5 18.5H20.5C21.6046 18.5 22.5 17.6046 22.5 16.5V7.5C22.5 6.39543 21.6046 5.5 20.5 5.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="7" cy="12" r="1.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <circle cx="12" cy="12" r="1.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <circle cx="17" cy="12" r="1.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
    </svg>
  );
};

export default MessageInputSvg;
